import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Products from './components/Products';
import FAQ from './components/FAQ';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-['Poppins',sans-serif]">
      <Header />
      <Hero />
      <About />
      <Services />
      <Products />
      <FAQ />
      <Projects />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
